import axios, { AxiosPromise } from 'axios';

import { IMaterial } from '../../../@types/model/masterData/material/material';
import { IMaterialUpsert } from '../../../@types/model/masterData/material/materialUpsert';

export default class MaterialHttpService {
    public static getMaterialData() : AxiosPromise<Array<IMaterial>> {
        return axios.get(`${API_URL}/v1/Material/GetAllWeb`);
    }

    public static addOrUpdateMaterial(upsert : IMaterialUpsert) : AxiosPromise<IMaterial> {
        return axios.post(`${API_URL}/v1/Material/PostMaterial`, upsert);
    }

    public static deleteMaterial(materialId : number) : AxiosPromise<IMaterial> {
        return axios.delete(`${API_URL}/v1/Material/Delete`, {
            params : { materialId },
        });
    }
}
